import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "place/enterprise"

class service {

    selectList(params) {
        return http.list(path + "/selectList", params);
    }

    getAllEnterprises() {
        let params = new URLSearchParams()
        params.set("status", "1")
        return http.list(path + "/selectAll", params);
    }

    getById(id) {
        return http.get(path + "/" + id + "?forceReadById=Y").then(response => {
            return response.data;
        })
    }

    getResume(type, param, allStatus = false) {

        return http.getResume(path, type, param, allStatus);

    }


}

export default new service();

